// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "6a920334" + "." + "9876af06de1cd5cc" + ".js";
};